import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MessagingService } from 'src/app/services/messaging.service';
import { FileManagerService } from '../../file-manager/file-manager.service';
import { ItemFilterPipe } from 'src/app/pipes/item-filter.pipe';
import { TdoOrganizerSlideshowDialogComponent } from 'src/app/main-interface/organizer/dialogs/tdo-organizer-slideshow-dialog/tdo-organizer-slideshow-dialog.component';

@Component({
  standalone: false,
  selector: 'app-patient-portal-correspondence',
  templateUrl: './patient-portal-correspondence.component.html',
  styleUrls: ['./patient-portal-correspondence.component.scss']
})
export class PatientPortalCorrespondenceComponent {

  activeAppointmentId: any;
  appointments: any[];
  patientId: string;

        
  constructor(
    public dialogRef: MatDialogRef<PatientPortalCorrespondenceComponent>,
    private readonly messagingService: MessagingService,
    private readonly fileManagerService: FileManagerService,
    private readonly itemFilterPipe: ItemFilterPipe,
    private readonly dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.activeAppointmentId = this.data.activeAppointmentId;
    this.appointments = this.data.appointments;
    this.patientId = this.data.patientId;

    // CL-618/CL-621: auto-open a specific document (e.g. from a "Send Link to Patient Only"
    // magic-link email) instead of requiring the patient to find and click it manually.
    if (this.data.targetDocumentId) {
      const targetAppointment = this.appointments?.find(a => a.AppointmentId === this.activeAppointmentId);
      const targetFile = targetAppointment?.correspondence?.find(f => f.DocumentID === this.data.targetDocumentId);
      if (targetFile) {
        // Defer to the next tick so this dialog finishes opening before the viewer dialog
        // stacks on top of it.
        setTimeout(() => this.openCorrespondenceFile(targetFile));
      }
    }
  }

  toggleCorrespondence (appointmentId){

    if (this.activeAppointmentId === appointmentId)
      this.activeAppointmentId = null;
    else
    this.activeAppointmentId = appointmentId;
  }

  close() {
    this.dialogRef.close();
  }

  expandAll(event: MatCheckboxChange){
    if (event.checked) 
      this.activeAppointmentId = "all";
    else
    this.activeAppointmentId = "";
  }

  openReport(report:any){
      console.log("Opening report:", report);
  
        let documentIds: string[] = [];
        documentIds.push(report.DocumentID);
    
        const config = new MatDialogConfig();
        config.panelClass = 'standard-dialog';
        config.data = documentIds;
        config.maxWidth = '100dvw';
        config.maxHeight = '100dvh';
        config.width = '98%';
        config.height = '98%';
        console.log('ReferrerPortalReferralDetailComponent openReport:', config);
        this.dialog.open(TdoOrganizerSlideshowDialogComponent, config).afterClosed().subscribe((res) => {
          //
        });    
    }
  openCorrespondenceFile(file){

    this.openReport(file);

    /*
    let windowOptions = [
      'toolbar=no',
      'location=no',
      'menubar=no',
      'height=' + screen.height,
      'width=' + screen.width,
      'fullscreen=yes' // only works in IE, but here for completeness
    ].join(',');
    const fileSource = this.fileManagerService.getDocumentImageUrl(this.patientId, file.DocumentFileName);
    this.messagingService.openPopUpWindow(fileSource, windowOptions, file.DocumentFileName, "", null, true, file.DocumentFileName);
    */
  }

  ContainsAppointmentCorrespondence(appointment: any) {
    return appointment.correspondence.length>0;
  }
}
